import { ReactElement } from "react";
import Container from "./Container";
import { SidebarTrigger } from "./ui/Sidebar";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/Avatar";
import Search from "./Search";
import { Bell, MessageCircle, Settings } from "lucide-react";

const Navbar = (): ReactElement => {
  return (
    <nav className="sticky top-0 h-[76px] py-5  bg-bgWhite z-10 shadow-sm">
      <Container className="flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <SidebarTrigger className="bg-primary hover:bg-bgWhite text-bgWhite hover:text-primary" />
          <Search value="" onSearchChange={() => {}} />
        </div>
        <div className="flex items-center space-x-3">
          <div className="w-[36px] h-[36px]  grid place-items-center cursor-pointer rounded-xl bg-primary">
            <Bell color="#FFFFFF" height={15} width={15} />
          </div>
          <div className="w-[36px] h-[36px]  grid place-items-center cursor-pointer rounded-xl bg-primary">
            <MessageCircle color="#FFFFFF" height={15} width={15} />
          </div>
          <div className="w-[36px] h-[36px]  grid place-items-center cursor-pointer rounded-xl bg-primary">
            <Settings color="#FFFFFF" height={15} width={15} />
          </div>
          <Avatar className="w-[36px] h-[36px] cursor-pointer rounded-xl border-[1.5px] border-primary">
            <AvatarImage src="https://github.com/shadcn.png" />
            <AvatarFallback></AvatarFallback>
          </Avatar>
        </div>
      </Container>
    </nav>
  );
};

export default Navbar;
